import React from "react";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Iconify from "../iconify/Iconify";

const tableStyle = {
  headStyles: { fillColor: [255, 255, 255], textColor: 0 },
  styles: { fontSize: 9, cellPadding: 4, valign: "middle" },
  margin: { left: 30, right: 30 },
};

const formatPlacement = (p) => {
  if (!p) return "";
  const name = [p.firstName, p.lastName].filter(Boolean).join(" ").trim();
  const loc = p.location ? ` (${p.location})` : "";
  return `${name}${loc}`.trim();
};

export default function TournamentPdfButton({ tournament, fullWidth = false }) {
  const handleCreatePdf = () => {
    if (!tournament) return;
    const doc = new jsPDF({ unit: "pt", format: "a4" });

    const title = tournament.tournamentName || "Turnier";
    const dateStr = tournament.tournamentDate
      ? dayjs(tournament.tournamentDate).format("DD.MM.YYYY")
      : "";
    const location = tournament.locationName
      ? ` · ${tournament.locationName}`
      : "";
    const header = `${title}${location}${dateStr ? " · " + dateStr : ""}`;

    doc.setFontSize(14);
    doc.text(header, 40, 40);
    doc.setFontSize(10);
    if (tournament.description) {
      doc.text(tournament.description, 40, 58);
    }

    const disciplines = Array.isArray(tournament.disciplines)
      ? tournament.disciplines
      : [];

    let startY = 80;
    if (!disciplines.length) {
      doc.text("Keine Disziplinen vorhanden.", 40, startY);
    }

    disciplines.forEach((discipline, idx) => {
      const name = discipline?.name || `Disziplin ${idx + 1}`;
      const beltGrades = Array.isArray(discipline?.beltGrades)
        ? discipline.beltGrades
        : [];

      doc.setFontSize(12);
      doc.text(name, 40, startY);

      const head = [
        ["Gürtelgrad", "Teilnehmer", "1. Platz", "2. Platz", "3. Platz"],
      ];
      const body = beltGrades.map((g) => {
        const placements = Array.isArray(g?.placements) ? g.placements : [];
        const p1 = placements.find((p) => p.place === 1) || placements[0];
        const p2 = placements.find((p) => p.place === 2) || placements[1];
        const p3 = placements.find((p) => p.place === 3) || placements[2];
        return [
          g?.grade || "",
          g?.participantCount ?? 0,
          formatPlacement(p1),
          formatPlacement(p2),
          formatPlacement(p3),
        ];
      });

      autoTable(doc, {
        startY: startY + 8,
        head,
        body: body.length ? body : [["", "", "", "", ""]],
        ...tableStyle,
      });

      startY = (doc.lastAutoTable && doc.lastAutoTable.finalY + 22) || startY;
    });

    const fileName = `${title.replace(/\s+/g, "_")}_${dayjs().format(
      "YYYYMMDD_HHmm"
    )}.pdf`;
    doc.save(fileName);
  };

  return (
    <Button
      size="small"
      fullWidth={fullWidth}
      variant="outlined"
      onClick={handleCreatePdf}
      startIcon={<Iconify icon="mdi:file-pdf-box" />}
    >
      PDF
    </Button>
  );
}
